export class SocialLoginAction {
  static type = '[AUTH] Social login';

  constructor(readonly provider: string) {}
}
